var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ms-dropdown-item",on:{"click":_vm.dropItemClick}},[(_vm.iconDropdown)?_c('div',{class:[
			'mr-2',
			_vm.iconNew ? 'mi-new' : 'mi',
			_vm.isSize16 ? 'mi-16' : 'mi-24',
			_vm.iconDropdown ? _vm.iconDropdown : '' ]}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }